import { useCallback } from 'react';

import { useEbookSubmissionItemsLazyQuery } from '../core/graphql/operation-hooks';
import { PintoEbookSubmissionItemsFilter } from '../core/graphql/types';

const INITIAL_LIMIT = 10;

const useQueryEbookSubmissionItems = () => {
  const [queryEbookSubmissionItems, { data, loading }] = useEbookSubmissionItemsLazyQuery({
    fetchPolicy: 'network-only',
  });

  const fetchEbookSubmissionItems = useCallback(
    (ebookSubmissionId: string, filter?: PintoEbookSubmissionItemsFilter) => {
      queryEbookSubmissionItems({
        variables: {
          ebookSubmissionId,
          filter: {
            ...filter,
            limit: filter?.limit || INITIAL_LIMIT,
          },
        },
      });
    },
    [queryEbookSubmissionItems],
  );

  return {
    fetchEbookSubmissionItems,
    ebookSubmissionItems: data?.ebookSubmissionItems,
    isLoadingEbookSubmissionItems: loading,
  };
};

export default useQueryEbookSubmissionItems;
